import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import 'normalize.css'
import './assets/global.sass'
import sms_button from './components/sms_button'
import Directives from './directives'

Vue.use(Directives)
Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.component('sms_button', sms_button)

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
new Vue({
  store,
  el: '#app',
  data () {
    return {
      session: {}
    }
  },
  render: h => h('div', { attrs: {id: 'app'} }, [h('router-view')]),
  created () {
    window.rootApp = this
  },
  router
})



// WEBPACK FOOTER //
// ./src/main.js